<template>
  <div class="input__wrap" :style="`width: ${width};`" :disabled="disabled">
    <span class="input__text">{{ title }}{{ (required) ? '*' : '' }}</span>
    <Multiselect v-model="inputValue"
                 :options="options"
                 :class="validationClass"
                 label="name"
                 :track-by="itemText"
                 :searchable="true"
                 :disabled="disabled"
                 :required="required"
                 :placeholder="placeholder"
                 :preserve-search="newItemFromSearch"
                 selectLabel=""
                 selectedLabel=""
                 deselectLabel=""
                 :allow-empty="true"
                 :maxHeight="400"
                 :tabindex="1"
                 :options-limit="50"
                 :loading="loading"
                 @open="open"
                 @select="valueChanged"
                 :open-direction="openDirection"
                 @search-change="inputChange"
    >
      <template  slot="option" slot-scope="{ option }">
        <div class="option" v-if="isUsers">
          <div class="user-avatar option__avatar" v-if="option.avatar !== 'no-avatar'">
            <img v-if="option.avatar !== null && option.avatar.file_size"
                 :src="option.avatar.url" :alt="option.name">
            <img v-else src="/img/svg/avatar__icon.svg" :alt="option.name">
          </div>
          <div class="option__name">
            {{ option.name }}
          </div>
        </div>
        <div class="option__name" v-if="!isUsers">
          {{ option.name }}
        </div>
      </template>
      <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
      <!-- eslint-disable-next-line vue/no-unused-vars -->
      <template slot="noResult" slot-scope="{ option }">Ничего не найдено</template>
      <!-- eslint-disable-next-line vue/no-unused-vars -->
      <template slot="noOptions" slot-scope="{ option }">Список пуст</template>
    </Multiselect>
    <slot v-if="hasValidationError" />
    <transition name="scaleDown">
            <span v-if="valid.type" class="input__valid" :class="'input__valid_' + valid.type">
                {{ valid.message }}
<!--                <img v-if=" valid.type === 'error' " src="/img/svg/error_icon.svg" alt="Ошибка" class="input__valid__icon">-->
<!--                <img v-if=" valid.type === 'warning' " src="/img/svg/warning_icon.svg" alt="Внимание" class="input__valid__icon">-->
<!--                <img v-if=" valid.type === 'success' " src="/img/svg/success_icon.svg" alt="Успешно" class="input__valid__icon">-->
            </span>
    </transition>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import Base from '@/components/page/Form/Vinput/Base/Base.vue'

export default {
  name: 'app-select',
  components: {
    Multiselect
  },
  inject: { formData: { from: 'formData', default: null } },
  extends: Base,
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    name: String,
    value: [Object, String],
    title: String,
    placeholder: [Object, String],
    width: {
      type: String,
      default: '100%'
    },
    newItemFromSearch: {
      type: Boolean,
      default: false
    },
    options: Array,
    isUsers: {
      type: Boolean,
      default: false
    },
    disabled: Boolean,
    openDirection: {
      type: String,
      default: 'auto'
    },
    valid: {
      type: Object,
      default: () => {
        return { type: null, message: '' }
      }
    },

    itemText: {
      type: String,
      default: 'name'
    }
  },
  computed: {
    inputValue: {
      get () {
        if (this.formData && this.name) {
          return this.formData[this.name] || this.defaultValue
        } else {
          return this.value || this.defaultValue
        }
      },
      set (val) {
        if (this.formData && this.name) {
          this.$set(this.formData, this.name, val)
        }
        this.$emit('change', val)
      }
    },
    validationClass () {
      return {
        input_error: this.valid.type && this.valid.type === 'error',
        input_warning: this.valid.type && this.valid.type === 'warning',
        input_success: this.valid.type && this.valid.type === 'success'
      }
    }
  },
  methods: {
    valueChanged (value) {
      this.inputValue = value
      this.$emit('value-changed', value)
    },
    inputChange (value) {
      if (this.newItemFromSearch) {
        this.$emit('search-changed', value)
      }
    },
    open () {
      this.$emit('open')
    }
  }
}
</script>

<style lang="scss" scoped>

.input {
  &__wrap {
    position: relative;
    display: block;

    &[disabled] {
      pointer-events: none;

      .input__text {
        color: $color_deactive;
      }

      .input {
        border: 1px solid $color_deactive;
      }
    }
  }

  &__text {
    display: block;
    margin-bottom: 10px;
    color: $color__brown;
  }

  &__valid {
    display: block;
    position: absolute;
    z-index: 99;
    top: auto;
    bottom: auto;
    transform: translateY(-5px) scaleY(1);
    transform-origin: top;
    left: 0;
    width: 100%;
    font-size: 14px;
    padding: 5px 15px 0 15px;
    color: $color__white;
    border-radius: 0 0 3px 3px;
    transition: .3s;

    &__icon {
      position: absolute;
      top: calc(50% - 12.5px);
      left: auto;
      right: -35px;
      animation: fadeIn .3s linear;
    }

    &_error {
      background-color: $color_error;
    }

    &_warning {
      background-color: $color_warning;
    }

    &_success {
      background-color: $color_success;
    }
  }

  &[disabled] {
    background: $color_main;
  }

  &:hover {
    border: 1px solid $color_second-light;
  }

  &:focus {
    box-shadow: inset 0 4px 4px rgba(23, 63, 125, 0.25);
  }
}

.option {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  &__avatar {
    margin-right: 10px;
    @include size(52px)
  }

  &__name {
    white-space: normal;
    line-height: 1.25;
  }
}
</style>
